import React, { useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import LoginPage from './components/LoginPage';
import Pricing from './components/Pricing';
import SEO from './components/SEO';
import { SuperHitProvider } from './contexts/SuperHitContext';
import SuperHitPopup from './components/SuperHitPopup';

function App() {
  return (
    <HelmetProvider>
      <SuperHitProvider>
        <Router>
          <div className="min-h-screen bg-neutral-950 text-white">
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/pricing" element={<Pricing />} />
            </Routes>
            <SuperHitPopup />
          </div>
        </Router>
      </SuperHitProvider>
    </HelmetProvider>
  );
}

export default App;
